<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-12 pt-3 pb-3 pl-4">
                <h3><i class="fas fa-users"></i> Grupos</h3>
            </div>
        </div>
        <GroupAdd v-if="showAdd" ref="GroupAdd" v-on:Back="onBack" />
        <GroupList v-else ref="GroupList" v-on:New="onNewGroup" v-on:Edit="onEditGroup" />
    </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import GroupAdd from './components/add/groupadd.vue'
import GroupList from './components/list/grouplist.vue'

export default {
  name: 'Group',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    GroupAdd,
    GroupList
  },
  mounted () {
    Tools.MinimizedSidebar()
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onNewGroup () {
      this.showAdd = true
    },
    onEditGroup (group) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.GroupAdd.onEdit(group)
      })
    },
    onBack () {
      this.showAdd = false
    },
    onLoad () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/group/group.vue